export class OrderDetailProductChangeAvailabilityFareDescriptionDetailView {
    type: string;
    text: string;
}